import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-item-loader',
    templateUrl: './item-loader.component.html',
    styleUrls: ['./item-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatProgressSpinnerModule]
})
export class ItemLoaderComponent {
    @Input() bgTransparent = false;
}
